import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { billing: () => import('./BillingPage.vue') },
} satisfies FeatureRoutes
